import React from "react";
import { useToastStateContext } from "../../contexts/ToastContext";
import { Toast } from "../../ui-kit";
import classnames from "classnames";
import styles from "./ToastContainer.module.scss";

export const ToastContainer = () => {
  const { toasts, placement = "topRight" } = useToastStateContext();

  return (
    <div className={classnames(styles.wrapper, styles[placement])}>
      {toasts &&
        toasts.map((toast) => (
          <Toast
            id={toast.id}
            key={toast.id}
            type={toast.type}
            message={toast.message}
          />
        ))}
    </div>
  );
};
